import React, { useState } from 'react';
import menudata from '../config/MenuData';
import { Formatter } from '../helpers/formatter';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const data = menudata.map(row => row);

const CategoryInput = ({ charge, subdata, handleOnChange, onChangePrice }) => {
    const [checkedState, setCheckedState] = useState(
        new Array(data.length).fill(false)
    );



    function renderTooltip() {
        return <Tooltip id="button-tooltip">
            <div>Ta opłata jest zablokowana ze względu na poniższy powód.</div>
        </Tooltip>
    };

    function ShowOverlay({ charhe }) {
        if (charge.isDisabled) {

            return <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip()}
            >

                <label className="form-check-label" htmlFor={`custom-checkbox-${charge.id}`}>{charge.name}</label>
            </OverlayTrigger>;
        }
        return <label className="form-check-label" htmlFor={`custom-checkbox-${charge.id}`}>{charge.name}</label>;
    };

    const blockInvalidChar = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();

    return (
        <div key={charge.id} className="d-flex bd-highlight">
            <div className="p-2 flex-grow-1 bd-highlight">
                <div className="form-check">

                    <input className="form-check-input"
                        type="checkbox"
                        id={`custom-checkbox-${charge.id}`}
                        name={charge.name}
                        value={charge.name}
                        disabled={charge.isDisabled}
                        checked={checkedState[charge.id]}
                        onChange={(e) => handleOnChange(charge, e.target.checked, subdata.charges)}
                    />
                    <ShowOverlay charge={charge} />
                </div>
            </div>
            {charge.price === 0 || charge.price === "0" || charge.isEditable ? <div className="p-2 bd-highlight d-flex justify-content-end">
                <input type="number" onKeyDown={blockInvalidChar} min="0" max="100000" step="0.01" placeholder="Podaj kwotę" name="price" onChange={e => onChangePrice(charge, e)} className="form-control" /><p style={{ marginTop: "5px" }}>&nbsp;zł</p>
            </div> : <div className="p-2 bd-highlight">{Formatter.toCurrency(charge.price)}</div>}
        </div>
    );
}
export default CategoryInput;